// extracted by mini-css-extract-plugin
export var legendIndicator = "_ab-1";
export var legendRight = "_ab-0";